import { createName } from '@/utils/create-name';

import {
  DEFAULT_ATTRIBUTES,
  DEFAULT_FILTER,
  DEFAULT_PARTITION_PAIRS,
  DEFAULT_SAMPLE_SIZE,
  DEFAULT_SUMMARY_PROMPT,
  DEFAULT_TIME_RANGE,
} from '../constants';
import { InsightsJobFormData } from '../types';

// Only used if presaved configurations haven't loaded
export function getDefaultFormData(): InsightsJobFormData {
  const defaultFormData: InsightsJobFormData = {
    timeRange: DEFAULT_TIME_RANGE,
    sample: DEFAULT_SAMPLE_SIZE,
    filter: DEFAULT_FILTER,
    partitionPairs: DEFAULT_PARTITION_PAIRS,
    summaryPrompt: DEFAULT_SUMMARY_PROMPT,
    name: createName('insights'),
    attributes: DEFAULT_ATTRIBUTES,
  };
  return defaultFormData;
}
